<template>
  <v-dialog v-model="isVisible" scrollable width="850">
    <v-card>
      <v-card-title
        class="headline primary white--text d-flex justify-space-between align-start"
      >
        <span style="max-width: 90%;">{{ itemData.nom }}</span>
        <v-icon @click="$emit('toggleModalDetails')" class="pa-1" dark>
          close
        </v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-row v-if="isLoading">
            <v-col cols="12" :md="itemData.customFields ? '8' : '12'">
              <v-skeleton-loader type="image, article" />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="d-flex flex-column justify-space-between"
            >
              <v-skeleton-loader type="article" />
              <v-skeleton-loader type="actions" />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" :md="readOnly ? '12' : '8'">
              <media-tabs :media="itemData.media" />
              <p class="text-h5">Descripció:</p>
              <p>
                {{ itemData.descripcio }}
              </p>
            </v-col>
            <v-col v-if="!readOnly" cols="12" md="4">
              <p class="text-h5">Detalls de l'activitat</p>
              <div
                v-for="row in itemData.customFields"
                :key="row.name"
                class="d-flex"
              >
                <div
                  v-for="customField in row"
                  :key="customField.name"
                  class="prd--activity-custom-fields"
                >
                  <v-select
                    v-if="customField.type === 'select'"
                    v-model="customField.value"
                    :items="customField.options"
                    :label="customField.label"
                    dense
                  />
                  <v-text-field
                    v-else
                    v-model="customField.value"
                    :type="customField.type"
                    :label="customField.label"
                    :suffix="customField.suffix"
                    dense
                  />
                </div>
              </div>
              <div class="my-4">
                <div
                  v-for="detail in itemData.details"
                  :key="detail.label"
                  class="mb-2"
                >
                  <span class="body-1">{{ detail.label }}:</span><br />
                  <span class="body-2">{{ detail.value || "No definit" }}</span>
                </div>
              </div>
              <div class="text-right">
                <v-btn v-if="canEdit" color="primary" small @click="updateItemData">
                  Desar canvis
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    mediaTabs: () => import("./ItemDialogMedia.vue"),
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    itemId: {
      type: Number,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      itemData: {},
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set() {
        this.$emit("toggleModalDetails")
      },
    },
    formValues() {
      const values = {}
      if (this.itemData.customFields) {
        const customFields = this.itemData.customFields.flat()
        for (const customField of customFields) {
          values[customField.name] = customField.value
        }
      }
      return values
    },
  },
  methods: {
    loadItemData() {
      if (this.readOnly) {
        this.service.getProfileActivitat(this.itemId).then(response => {
          this.itemData = response.data
          this.isLoading = false
        })
      } else {
        this.service.getProfileSessioActivitat(this.itemId).then(response => {
          this.itemData = response.data
          this.isLoading = false
        })
      }
    },
    updateItemData() {
      this.service
        .updateProfileSessioActivitat(this.itemId, this.formValues)
        .then(() => {
          this.$emit("loadKanban")
          this.$emit("toggleModalDetails")
        })
        .catch(error => {
          this.$notifyErrorByStatusCode(error.response.status)
        })
    },
  },
  mounted() {
    this.loadItemData()
  },
  watch: {
    itemId: function() {
      this.isLoading = true
      this.loadItemData()
    },
  },
}
</script>

<style scoped>
.prd--activity-custom-fields:not(:last-child) {
  margin-right: 6px;
}
</style>
